<template>
	<div class="page-content">
		<div class="cotainer">
			<div class="order-detail">
				<!-- 班型 -->
				<div class="order-group" v-if="orderType == 1 || orderType == 2">
					<div class="st-name">
						<div class="name">
							<img src="../../assets/images/icon_car.png" alt="">
							<span>{{orderInfo.goods_info.store_name}}</span>
						</div>
						<div class="order-number" @click="copy(orderInfo.order_info.order_sn)">订单编号：{{orderInfo.order_info.order_sn}}</div>
					</div>
					<div class="class-type">
						<div class="top">
							<span>{{orderInfo.goods_info.goods_name}}</span>
							<div class="group" v-if="orderType == 2">拼团</div>
						</div>
						<div class="mid">
							<div class="tag">{{orderInfo.goods_info.car_2distribution}}</div>
							<div class="tag">{{orderInfo.goods_info.car_take}}</div>
							<div class="tag">拿本时长{{orderInfo.goods_info.time_long}}天</div>
						</div>
						<div class="bot" v-if="orderType == 2">
							<span class="old-price"><em class="money">￥{{orderInfo.goods_info.goods_price}}</em>元</span>
							<span class="group-price">{{orderInfo.goods_info.need}}人团：￥{{orderInfo.goods_info.prices}}元</span>
						</div>
						<!-- <div class="bot" v-if="orderType == 2">60天拿本 班车接送 周末训练</div> -->
					</div>
				</div>
				<!-- 优惠券 -->
				<div class="order-coupon" v-if="orderType == 3">
					<div class="st-name">
						<div class="name">
							<img src="../../assets/images/icon_car.png" alt="">
							<span v-if="orderInfo.coupon_car.type == 1">驾校优惠券</span>
							<span v-else>平台优惠券</span>
						</div>
						<div class="order-number" @click="copy(orderInfo.order_info.order_sn)">订单编号：{{orderInfo.order_info.order_sn}}</div>
					</div>
					<div class="class-type">
						<div class="top">
							<span>{{orderInfo.coupon_car.name}}</span>
							<div class="vouchers">券</div>
							<div class="price">￥{{orderInfo.coupon_car.price}}元</div>
						</div>
						<div class="mid">
							<div class="tag">{{orderInfo.coupon_car.short_name}}</div>
						</div>
						<div class="order-money">
							实付<span>￥{{orderInfo.order_info.total_amount}}元</span>
						</div>
					</div>
				</div>
				<!-- 礼物[礼物不允许退款,下面不渲染数据] -->
				<div class="order-gift" v-if="orderType == 4">
					<div class="order-number">
						<img src="../../assets/images/icon_bd.png" alt="">
						<span>订单编号：27343920</span>
					</div>
					<div class="gift-name">
						<div class="img-box">
							<img src="../../assets/images/icon_huojian_big.png" alt="" class="gift-img">
						</div>
						<div class="info">
							<div class="top">
								<span>火箭(打赏李教练)</span>
								<span class="price">￥1999<em>.00元</em></span>
							</div>
							<div class="bot">x1</div>
						</div>
					</div>
					<div class="order-money">
						<div class="line"></div>
						<div class="price">实付：<span>￥1999.00元</span></div>
					</div>
				</div>
			</div>
			<div class="refund-info">
				<div class="money">退款金额：￥{{orderInfo.order_info.total_amount}}</div>
				<div class="reason-l">退款理由（必填）</div>
        <textarea v-model="reason" placeholder="请填写您的退款理由"></textarea>
			</div>
		</div>
		<div class="footer">
			<div class="btn" @click="reFoundBtn">提交</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ApplyRefund',
	components: {},
	data() {
		return {
      		orderType: 1, 		//订单类型
      		reason: '', 		//退款理由
			orderInfo:{
				goods_info:{},
				order_info:{},
				userinfo:{},
				coupon_car:{},
			},
    	}
	},
	created() {
		var order_id = this.$route.query.order_id;

		//订单信息获取
		this.$ajax.get('m/trade/order_info?id='+order_id,{}).then(res=>{
			this.orderInfo = res;
			switch (parseInt(res.order_prom_type)) {
				case 1219:	//报名学车
					this.orderType = 1;break;
				case 1221:	//拼团学车
					this.orderType = 2;break;
				case 1223:  //优惠卷
					this.orderType = 3;break;
				case 1225:	//礼物
					this.orderType = 4;
					this.$toast.text('礼物暂不允许退款~');
					setTimeout(()=>{
						this.$router.push({name:'MyOrder'})
					},2000)
					break;
				default:
					this.$toast.text('订单类型错误~');
					setTimeout(()=>{
						this.$router.push({name:'MyOrder'})
					},2000)
			}
			if(res.refund_goods){
				this.reason = res.refund_goods.reason;
			}
		})
	},
	methods: {
		reFoundBtn(){
			if(this.reason == ''){
				this.$toast.text('请填写退款理由');return false;
			}
			var that = this;
			this.$dialog({
				title: "退款提示",
				content: "是否确定退款?",
				onOkBtn(event) {  //确定按钮点击事件
					this.close(); //关闭对话框
					that.$ajax.post('m/refund/refund_handld',{
						id:that.orderInfo.order_info.order_id,
						reason:that.reason,
					}).then(res=>{
						that.$toast.text(res);
						setTimeout(()=>{
							//that.$router.go(-1);
							that.$router.push({name:'ODRefund',query:{id:that.orderInfo.order_info.order_id}})
						},2000)
					})
				},
			});
		},
		reFoundRequest(){

		},
		copy(text){
			const input = document.createElement('input')
			document.body.appendChild(input)
			input.setAttribute('value', text)
			input.select()
			if (document.execCommand('copy')) {
				document.execCommand('copy')
				this.$toast.text('复制成功');
			}
			document.body.removeChild(input)
		}
	},
	mounted() {

	}
}
</script>

<style lang="less" scoped>
	.page-content {
		width: 100%;
		height: 100%;
		.cotainer {
			width: 100%;
			height: 100%;
			box-sizing: border-box;
			padding: 15px 15px 60px;
			.order-detail {
				width: 100%;
				background-color: #fff;
				border-radius: 3px;
				box-shadow: 0px 0px 12px rgba(0,0,0,0.08);
				.order-group {
					width: 100%;
					.st-name {
						width: 100%;
						box-sizing: border-box;
						padding: 10px;
						.name {
							display: flex;
							align-items: center;
							span {
								margin-left: 5px;
								font-size: 15px;
								color: #333;
							}
							.status {
								flex: 1;
								text-align: right;
								color: #EB273B;
							}
						}
						.order-number {
							box-sizing: border-box;
							padding-left: 19px;
							font-size: 14px;
							color: #999;
							margin-top: 5px;
						}
					}
					.class-type {
						width: 100%;
						box-sizing: border-box;
						padding: 10px;
						border-top: 1px #E2E2E2 solid;
						.top {
							width: 100%;
							display: flex;
							align-items: center;
							span {
								font-size: 15px;
								color: #333;
							}
							.group {
								width: 32px;
								height: 20px;
								background-color: #FF808E;
								border-radius: 3px;
								line-height: 20px;
								text-align: center;
								font-size: 12px;
								color: #fff;
								margin-left: 5px;
							}
						}
						.mid {
							width: 100%;
							display: flex;
							flex-wrap: wrap;
							margin-top: 10px;
							.tag {
								height: 20px;
								line-height: 20px;
								background-color: #F8F8F8;
								border-radius: 3px;
								font-size: 12px;
								color: #666;
								margin-right: 5px;
								box-sizing: border-box;
								padding: 0 5px;
							}
						}
						.bot {
							width: 100%;
							margin-top: 10px;
							display: flex;
							align-items: center;
							.old-price {
								font-size: 14px;
								color: #999;
								margin-right: 10px;
								.money {
									font-style: normal;
									text-decoration: line-through;
									margin-right: 3px;
								}
							}
							.group-price {
								font-size: 14px;
								color: #EB273B;
							}
						}
						.order-money {
							width: 100%;
							box-sizing: border-box;
							padding: 10px 0;
							display: flex;
							align-items: center;
							justify-content: flex-end;
							border-top: 1px #E2E2E2 solid;
							font-size: 14px;
							margin-top: 10px;
							span {
								color: #EB273B;
							}
						}
					}
				}
				.order-single {
					width: 100%;
					height: 100%;
					box-shadow: 0px 0px 12px rgba(0,0,0,0.08);
					border-radius: 3px;
					.st-name {
						width: 100%;
						box-sizing: border-box;
						padding: 10px;
						border-bottom: 1px #E2E2E2 solid;
						.name {
							display: flex;
							align-items: center;
							span {
								margin-left: 5px;
								font-size: 15px;
								color: #333;
							}
						}
						.order-number {
							box-sizing: border-box;
							padding-left: 19px;
							font-size: 14px;
							color: #999;
							margin-top: 5px;
						}
					}
					.class-type {
						width: 100%;
						box-sizing: border-box;
						padding: 10px;
						border-bottom: 1px #E2E2E2 solid;
						.top {
							width: 100%;
							display: flex;
							align-items: center;
							color: #333;
							span {
								font-size: 15px;
							}
							.price {
								font-size: 14px;
							}
						}
						.mid {
							width: 100%;
							display: flex;
							flex-wrap: wrap;
							margin-top: 10px;
							.tag {
								height: 20px;
								line-height: 20px;
								background-color: #F8F8F8;
								border-radius: 3px;
								font-size: 12px;
								color: #666;
								margin-right: 5px;
								box-sizing: border-box;
								padding: 0 5px;
							}
						}
						.bot {
							width: 100%;
							margin-top: 10px;
							font-size: 14px;
							color: #666;
						}
					}
					.order-money {
						width: 100%;
						box-sizing: border-box;
						padding: 10px 0;
						display: flex;
						align-items: center;
						justify-content: flex-end;
						border-top: 1px #E2E2E2 solid;
						font-size: 14px;
						margin-top: 10px;
						span {
							color: #EB273B;
						}
					}
				}
				.order-coupon {
					width: 100%;
					height: 100%;
					box-shadow: 0px 0px 12px rgba(0,0,0,0.08);
					border-radius: 3px;
					.st-name {
						width: 100%;
						box-sizing: border-box;
						padding: 10px;
						border-bottom: 1px #E2E2E2 solid;
						.name {
							display: flex;
							align-items: center;
							span {
								margin-left: 5px;
								font-size: 15px;
								color: #333;
							}
						}
						.order-number {
							box-sizing: border-box;
							padding-left: 19px;
							font-size: 14px;
							color: #999;
							margin-top: 5px;
						}
					}
					.class-type {
						width: 100%;
						box-sizing: border-box;
						padding: 10px 10px 0;
						.top {
							width: 100%;
							display: flex;
							align-items: center;
							justify-content: space-between;
							span {
								font-size: 15px;
								color: #333;
							}
							.vouchers {
								width: 32px;
								height: 20px;
								background-color: #6FCBF3;
								border-radius: 3px;
								line-height: 20px;
								text-align: center;
								font-size: 12px;
								color: #fff;
								margin-left: 5px;
							}
							.price {
								font-size: 15px;
								color: #EB273B;
								flex: 1;
								text-align: right;
							}
						}
						.mid {
							width: 100%;
							display: flex;
							flex-wrap: wrap;
							margin-top: 10px;
							.tag {
								height: 20px;
								line-height: 20px;
								background-color: #F8F8F8;
								border-radius: 3px;
								font-size: 12px;
								color: #666;
								margin-right: 5px;
								box-sizing: border-box;
								padding: 0 5px;
							}
						}
					}
					.order-money {
						width: 100%;
						box-sizing: border-box;
						padding: 10px 0;
						display: flex;
						align-items: center;
						justify-content: flex-end;
						border-top: 1px #E2E2E2 solid;
						font-size: 14px;
						margin-top: 10px;
						span {
							color: #EB273B;
						}
					}
				}
				.order-gift {
					width: 100%;
					height: 100%;
					box-shadow: 0px 0px 12px rgba(0,0,0,0.08);
					border-radius: 3px;
					.order-number {
						width: 100%;
						height: 42px;
						box-sizing: border-box;
						padding: 10px;
						border-bottom: 1px #E2E2E2 solid;
						display: flex;
						align-items: center;
						font-size: 14px;
						color: #999;
						img {
							margin-right: 5px;
						}
					}
					.gift-name {
						width: 100%;
						box-sizing: border-box;
						padding: 10px;
						display: flex;
						.img-box {
							width: 60px;
							height: 60px;
							box-sizing: border-box;
							padding: 8px 5px;
							border-radius: 3px;
							border: 1px #E2E2E2 solid;
							margin-right: 10px;
							.gift-img {
								width: 100%;
								height: 100%;
								object-fit: cover;
							}
						}

						.info {
							width: 60%;
							flex: 1;
							.top {
								width: 100%;
								display: flex;
								align-items: center;
								justify-content: space-between;
								font-size: 15px;
								color: #333;
								.price {
									em {
										font-style: normal;
										font-size: 12px;
									}
								}
							}
							.bot {
								width: 100%;
								margin-top: 5px;
								display: flex;
								justify-content: flex-end;
								font-size: 12px;
								color: #999;
							}
						}
					}
					.order-money {
						width: 100%;
						box-sizing: border-box;
						padding: 0 10px 10px;
						.line {
							width: 100%;
							height: 1px;
							background-color: #E2E2E2;
						}
						.price {
							font-size: 14px;
							color: #666;
							margin-top: 10px;
							text-align: right;
							span {
								color: #EB273B;
							}
						}
					}
				}
			}
			.refund-info {
				width: 100%;
				height: calc(100% - 177px);
				box-shadow:0px 0px 12px rgba(0,0,0,0.08);
				border-radius:3px;
				margin-top: 15px;
				box-sizing: border-box;
				padding: 10px;
        textarea{
          border: 1px solid #eeeeee;
          width: 100%;
          min-width: 100%;
          max-width: 100%;
          min-height: 120px;
          padding: 6px 10px;
          margin-top: 10px;
          outline-style: none;
          box-shadow: unset;
        }
				div {
					font-size: 15px;
					color: #333;
				}
				.reason-l {
					margin-top: 10px;
				}
				.reason {
					width: 100%;
					height: 260px;
					border-radius: 3px;
					margin-top: 5px;
					font-size: 13px;
					color: #333;
					font-family:'Microsoft YaHei';
				}
			}
		}
		.footer {
			width: 100%;
			height: 60px;
			position: fixed;
			bottom: 0;
			left: 0;
			border-top: 1px #E2E2E2 solid;
			box-sizing: border-box;
			padding: 10px 15px;
			background-color:#fff;
			.btn {
				width: 100%;
				height: 100%;
				line-height: 40px;
				text-align: center;
				background:linear-gradient(45deg,rgba(60,67,236,1) 0%,rgba(0,194,255,1) 100%);
				border-radius:25px;
				font-size: 15px;
				font-weight: bold;
				color: #fff;
			}
		}
	}
</style>
